import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductUnlocked = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 10.25H7.75V7C7.75 4.6567 9.6567 2.75 12 2.75C14.3433 2.75 16.25 4.6567 16.25 7C16.25 7.4141 16.5859 7.75 17 7.75C17.4141 7.75 17.75 7.4141 17.75 7C17.75 3.8296 15.1709 1.25 12 1.25C8.8291 1.25 6.25 3.8296 6.25 7V10.25H5C4.0352 10.25 3.25 11.0352 3.25 12V21C3.25 21.9648 4.0352 22.75 5 22.75H19C19.9648 22.75 20.75 21.9648 20.75 21V12C20.75 11.0352 19.9648 10.25 19 10.25ZM19.25 21C19.25 21.1377 19.1377 21.25 19 21.25H5C4.8623 21.25 4.75 21.1377 4.75 21V12C4.75 11.8623 4.8623 11.75 5 11.75H19C19.1377 11.75 19.25 11.8623 19.25 12V21Z"
        fill={color}
      />
      <path
        d="M12 13.75C11.0352 13.75 10.25 14.5352 10.25 15.5C10.25 16.1954 10.6609 16.7924 11.25 17.0745V18.5C11.25 18.9141 11.5859 19.25 12 19.25C12.4141 19.25 12.75 18.9141 12.75 18.5V17.0745C13.3391 16.7925 13.75 16.1955 13.75 15.5C13.75 14.5352 12.9648 13.75 12 13.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductUnlocked.displayName = 'ProductUnlocked';
